// Padding prevents the scrollbar from overlapping with react-rnd
// resize handles on the right and bottom edges.
export const LEGEND_WRAPPER_ITEMS_PADDING = {
  paddingRight: 5,
  paddingBottom: 5
};
